import { render } from "./distribution-form.vue?vue&type=template&id=56c598d8"
import script from "./distribution-form.vue?vue&type=script&lang=js"
export * from "./distribution-form.vue?vue&type=script&lang=js"

import "./distribution-form.vue?vue&type=style&index=0&id=56c598d8&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__